//import hooks
import { useTranslation } from "react-i18next";

// import componnets
import Carousel from "react-bootstrap/Carousel";
import { Row, Col, Container } from "react-bootstrap";

// import data
import headerBanners from "../../utils/data/headerBanners";
import productsData from "../../utils/data/productsData";

// import styles
import "../../assets/css/header.css";
// import addToCart from "../assets/svg-icons/add-to-cart.svg"

const Header = () => {
    const [t] = useTranslation("global");
    return (
        <header className="header">
            <Container>
                <Carousel>
                    {headerBanners.map((i) => {
                        return (
                            <Carousel.Item>
                                <div className="carousel-div">
                                    <Row>
                                        <Col className="carousel-col">
                                            <h1>
                                                <span className="banner-blue-text">
                                                    {i.h1}
                                                </span>{" "}
                                                <span>{i.h2}</span>
                                            </h1>
                                            <p>{i.p}</p>
                                            {i.link ? (
                                                <a
                                                    href={i.link}
                                                    className="carousel-btn"
                                                >
                                                    <div className="add-to-cart-svg"></div>
                                                    <span>
                                                        {t("header.shopNow")}
                                                    </span>
                                                </a>
                                            ) : (
                                                ""
                                            )}
                                        </Col>
                                        <Col className="carousel-col">
                                            <img src={i.img} alt="img" />
                                        </Col>
                                    </Row>
                                </div>
                            </Carousel.Item>
                        );
                    })}
                </Carousel>

                <div className="products-row">
                    <ul>
                        {productsData.map((i) => (
                            <li key={i.id}>
                                <a href={i.link} className="product-card-link">
                                    <img
                                        src={i.img}
                                        alt={i.title}
                                        className="product-card-img"
                                    />
                                    <h3 className="product-card-h">
                                        {i.title}
                                    </h3>
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </Container>
        </header>
    );
};

export default Header;
